import React from 'react';
import '../styles/About.css';
import ryanProfile from '../assets/images/ryan.jpg';

const About: React.FC = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <h2 className="section-title">About Me</h2>

        <div className="about-content">
          <div className="about-image">
            <div className="image-placeholder">
              <img src={ryanProfile} alt="Ryan Kennedy profile" className="profile-image" />
            </div>
          </div>

          <div className="about-text">

            <p>
              I'm Ryan Kennedy, a passionate and driven cybersecurity student at the University of Technology Sydney, graduating in Autumn 2025.
              I've built a strong foundation in security engineering, software development,
              and system administration through hands-on experience at companies like Canva and
              Atlassian. My work has ranged from Enterprise Security and penetration testing to
              infrastructure support and software configuration.
            </p>

            <p>
              I'm confident working with a wide range of tools and technologies including Python, Java, Git, SQL, Splunk, Terraform, AWS, and Linux.
              Outside of formal roles, I stay active in the cybersecurity community as an member of the UTS Cybersecurity society,
              and I love sharpening my skills through CTFs and personal projects.
            </p>

            <div className="about-details">
              <div className="detail-item">
                <span className="detail-label">Experience:</span>
                <span className="detail-value">3+ Years</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Education:</span>
                <span className="detail-value">Bachelor of Cybersecurity</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Location:</span>
                <span className="detail-value">Australia</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Email:</span>
                <span className="detail-value">contact@ryankennedy.au</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 